// extracted by mini-css-extract-plugin
export default {"title":"Quote_title__KhADo","subTitle":"Quote_subTitle__rko9M","license":"Quote_license__jvamG","details":"Quote_details__-28bn","contactBtn":"Quote_contactBtn__1Fygd"};